import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { getYearLabel } from '../../../Common/Util/getYearLabel';
import { useBasicBenefitsChartsDataContext } from './hooks/useBasicBenefitsChartsDataContext';

export const AverageValuePerYear = () => {
    const { chartData } = useBasicBenefitsChartsDataContext();

    const rawData = chartData?.averageValues?.annual || [];

    const series = [
        {
            name: 'Valor Médio por Família',
            data: rawData.map(item => Number(item.value))
        }
    ];

    return (
        <SimpleBars
            title="Valor Médio por Família - Anual"
            horizontal={false}
            subtitles={rawData.map(item => getYearLabel(item.ano))}
            series={series}
        />
    );
};
